module.exports = __webpack_public_path__ + "static/image/main/card/image-1.ver2_0_2.png?e4e4591b";